import React, { useState, useEffect } from 'react'
import { X } from "react-feather"
import { searchAutocompleteClientSide } from '../helper/api';
import {AppTheme} from "../helper/enums";
import SearchInput from "./shared/SearchInput";
import { getLinkObjectFromTeaser } from '../helper/link';
import { TeaserEntry } from '../helper/interfaces';

export type NavigationSearchProps = {
  toggleOverlay: Function;
};

function NavigationSearch(props: NavigationSearchProps) {
  const [searchText, setSearchText] = useState("")
  const [searchHints, setSearchHints] = useState<TeaserEntry[]>([])

  const searchUrl = `/search?query=${encodeURIComponent(searchText)}&sort=relevance`

  const handleClick = (searchUrlClicked) => {
    props.toggleOverlay();

    if(window.navigateMainViewTo) {
      window.navigateMainViewTo(searchUrlClicked);
    } else {
      window.location.href = searchUrlClicked
    }

    setTimeout(() => {
      props.toggleOverlay();
    }, 500);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      if (!navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
        handleClick(searchUrl)
      }
    }
  };

  const searchAutocomplete = async () => {
    const result = await searchAutocompleteClientSide(searchText)
    setSearchHints(result as TeaserEntry[])
  }

  useEffect(() => {
    if(searchText?.length > 2) {
      searchAutocomplete()
    }
    else {
      setSearchHints([]);
    }

  }, [searchText])

  return (
      <React.Fragment>
        <div className="nav-search">
          {process.env.NEXT_PUBLIC_APP_THEME == AppTheme.nn
            ? (
              <div className="flex items-center gap-4">
                <SearchInput
                  onSearchClick={() => handleClick(searchUrl)}
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  onKeyDown={handleKeyDown}
                  placeholder="Suche"
                />
              </div>
            )
            : (
              <div className="flex items-stretch nav-search-wrapper">
                <input
                  type="text"
                  placeholder="Nach Inhalten und Orten suchen..."
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  onKeyDown={handleKeyDown}
                  style={{ flexGrow: 1, marginRight: '8px' }}
                  aria-label="Nach Inhalten und Orten suchen..."
                />

                <a href={searchUrl} style={{ border: 'none', background: 'none' }} onClick={(e) => {e.preventDefault(); handleClick(searchUrl)}} className="search-icon-link" aria-label="Suche">
                  <i  className="icon-suche" aria-label="Suche" />
                </a>
              </div>
            )
          }
          { searchHints &&
            <div>
              {
                searchHints?.map((entry: TeaserEntry) => {
                  const link = getLinkObjectFromTeaser(entry).internalLink;
                  return link && entry ? <div className="search_hint" key={entry.id}>
                    <i className="icon-pfeil mr-3"></i>
                    <a href={link} style={{ border: 'none', background: 'none' }} onClick={(e) => {e.preventDefault(); handleClick(link)}} className="search-icon-link" >
                      {entry.title}
                    </a>
                  </div> : <></>
                })
              }
            </div>
          }
        </div>
          
        </React.Fragment>
    )
}

export default NavigationSearch

